'use strict';
import angular from 'angular';
import './scripts/workflowclient.ctrls';
import './scripts/workflowclient.services';

import workflowClientViewHtmlUrl from './views/workflowClientView.html';

angular.module('workflowclient', [
    'workflowclient.ctrls',
    'workflowclient.services'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('viewWorkflowClient', {
                parent: 'layout',
                url: '/items/workflowclient/:id',
                templateUrl: workflowClientViewHtmlUrl,
                controller: 'WorkflowClientViewController',
            })
    }]);
